import * as Yup from "yup";
const allowedImageFormats = [
  "image/png",
  "image/jpg",
  "image/jpeg",
  "image/webp",
];

const maxFileSize = (size: number = 10) => size * 1024 * 1024;

const EmailAddress = Yup.string()
  .label("Email")
  .required()
  .trim()
  .matches(/^([\w.-]+@([\w-]+\.)+[\w-]{2,4})?$/, "Invalid Email Address");

const ContactNumber = Yup.number()
  .label("Phone")
  .typeError("Phone number must be a valid number")
  .required("Phone number is required")
  .test("valid-phone", "Enter a valid phone number", (value: any) => {
    const phoneNumber = value?.toString();
    return phoneNumber && /^[6-9]\d{9}$/.test(phoneNumber);
  });

const FullNameSchema = Yup.string()
  .label("full name")
  .trim()
  .required("Full name is required")
  .min(3, "Minimum 3 characters are required")
  .max(30, "Maximum 30 characters are allowed")
  .matches(/^[a-zA-Z\s]*$/, "Special characters are not allowed");

const TextEditor = ({
  label,
  min,
  max,
  isRequired,
}: {
  label: string;
  min: number;
  max?: number;
  isRequired: boolean;
}) =>
  Yup.string()
    .label(label)
    .trim()
    .when([], {
      is: () => isRequired,
      then: (schema) => schema.required(`${label} is required`),
    })
    .test(
      "min-length",
      `Minimum ${min} characters are required`,
      (value = "") => {
        const textContent = value.replace(/<[^>]*>/g, ""); // Remove HTML tags
        const charactersLength = textContent.length;
        return charactersLength >= min;
      }
    )
    .test(
      "max-length",
      `Maximum ${max} characters are allowed`,
      (value = "") => {
        if (max === undefined || max === null) return true; // Skip max validation if not provided
        const textContent = value.replace(/<[^>]*>/g, ""); // Remove HTML tags
        const charactersLength = textContent.length;
        return charactersLength <= max;
      }
    );

export const validationValues = {
  EmailAddress,
  ContactNumber,
  TextEditor,
  FullNameSchema,
  allowedImageFormats,
  maxFileSize,
};
